import { useEffect, useState } from 'react';

const useThemeTextColor = (cssVariable = '--text-muted-color') => {
  const [textColor, setTextColor] = useState('black');

  useEffect(() => {
    const updateTextColor = () => {
      const root = document.documentElement;
      const style = getComputedStyle(root);
      const color = style.getPropertyValue(cssVariable).trim();
      setTextColor(color);
    };

    updateTextColor(); 
    window.addEventListener('themeChanged', updateTextColor);

    return () => {
      window.removeEventListener('themeChanged', updateTextColor);
    };
  }, [cssVariable]);

  return textColor;
};

export default useThemeTextColor;